<template>
  <div>
    <table
      class="table table-striped table-bordered table-responsive nowrap w-100 datatable"
    >
      <thead>
        <tr>
          <th
            v-for="col in columns"
            :key="col.key"
            :class="col.thClass"
            :style="col.thStyle"
          >
            {{ col.label }}
          </th>
        </tr>
      </thead>

      <!-- Loading state: parent can provide a named slot `loading` or set the `loading` prop -->
      <tbody v-if="loading">
        <tr>
          <td :colspan="columns.length" class="text-center">
            <slot name="loading">
              <div class="text-warning my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </slot>
          </td>
        </tr>
      </tbody>

      <!-- Empty state: parent can provide a named slot `empty` -->
      <tbody v-else-if="!loading && Array.isArray(rows) && rows.length === 0">
        <tr>
          <td :colspan="columns.length" class="text-center">
            <slot name="empty">
              <div class="text-center my-2">
                <strong>No data found</strong>
              </div>
            </slot>
          </td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr
          v-for="(row, idx) in rows"
          :key="rowKey(row, idx)"
          :class="rowClass"
        >
          <td
            v-for="col in columns"
            :key="col.key"
            :class="col.tdClass"
            :style="col.tdStyle"
          >
         
            <slot
              :name="`cell(${col.key})`"
              :row="row"
              :col="col"
              :index="idx"
              :value="getValue(row, col.key)"
            >
              {{ formatter(row[col.key], col) }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ReDataTable",
  props: {
    // `columns` must be an array of column descriptor objects.
    columns: { type: Array, required: true },
    // `rows` is the array of data objects to render. 
    rows: { type: Array, default: () => [] },
    // Optional CSS class applied to each <tr> (row-level styling)
    rowClass: { type: String, default: "" },
    // When `loading` is true the component will render the `loading`
    loading: { type: Boolean, default: false },
  },
  methods: {
     getValue(row, key) {
      if (!key || !row) return undefined;
      return key.split(".").reduce((value, segment) => {
        if (value == null) return undefined;
        return value[segment];
      }, row);
    },
    formatter(value, col) {
      if (col.formatter && typeof col.formatter === "function") {
        return col.formatter(value);
      }
      return value ?? "";
    },
    rowKey(row, idx) {
      // Prefer a stable `id` from the row object for the element key, but
      // fall back to the index when no id is present. This keeps Vue's list
      // diffing stable when possible.
      return row.id ?? idx;
    },
  },
};
</script>

<style scoped>
th {
  vertical-align: top;
  white-space: normal;
}
</style>
